export const initialHomeState: TVDLHomeState = {
  type: 'default',
  title: null,
  unresolvedURL: null,
  resolvedURL: null,
  isEdit: false,
  haveBackButton: false
};

export type TVDLHomeState =
  | {
      type: 'default';
      title: null;
      resolvedURL: null;
      unresolvedURL: null;
      isEdit: boolean;
      haveBackButton: false;
      isNotEditable?: boolean;
    }
  | {
      type: 'iframe';
      title: string;
      resolvedURL: string;
      unresolvedURL: string;
      isEdit: null;
      haveBackButton: true;
      isNotEditable?: boolean;
    };
